/* =============================================================
   Footer — United Dream Mongolia
   Design: Dark navy footer with links and social icons
   ============================================================= */
import { Globe } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0D0A2E] border-t border-white/10">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg overflow-hidden shadow-md shadow-violet-500/40">
                <img src="/logo-64.png" alt="United Dream Mongolia" className="w-full h-full object-cover" />
              </div>
              <div>
                <div className="type-heading text-white text-base">United Dream</div>
                <div className="type-overline text-[#7C3AED]" style={{ fontSize: '0.6rem' }}>Mongolia</div>
              </div>
            </div>
            <p className="type-body text-white/40 text-sm max-w-xs">
              Монголын иргэдийн дэлхийн мөрөөдлийг биелүүлэхэд туслах мэргэжлийн визийн зөвлөх компани.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="type-label text-white text-sm mb-4">Холбоосууд</h4>
            <ul className="space-y-2.5">
              {[
                { label: "Нүүр", href: "#home" },
                { label: "Үйлчилгээ", href: "#services" },
                { label: "Бидний тухай", href: "#about" },
                { label: "Холбоо барих", href: "#contact" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-white/50 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="type-label text-white text-sm mb-4">Холбоо барих</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-white/50 text-sm">
                <span>📞</span><span>8080-6633</span>
              </li>
              <li className="flex items-center gap-2 text-white/50 text-sm">
                <span>✉️</span><span>partner@untdream.com</span>
              </li>
              <li className="flex items-start gap-2 text-white/50 text-sm">
                <span className="mt-0.5">📍</span><span>СУИС-ийн урд Gem Castle төв 9 давхарт 907 тоот</span>
              </li>
              <li className="flex items-center gap-2 text-white/50 text-sm">
                <span>🕐</span><span>Даваа–Баасан 09:00–18:00 | Ням 13:00–17:00</span>
              </li>
            </ul>
          </div>

          {/* Countries */}
          <div style={{ display: 'none' }}>
            <h4 className="type-label text-white text-sm mb-4">Улс орнууд</h4>
            <ul className="space-y-2.5">
              {[
                { flag: "🇺🇸", name: "АНУ" },
                { flag: "🇦🇺", name: "Австрали" },
                { flag: "🇨🇦", name: "Канад" },
                { flag: "🇨🇿", name: "Чех Улс" },
                { flag: "🇮🇪", name: "Ирланд" },
              ].map((c) => (
                <li key={c.name}>
                  <a
                    href="#services"
                    onClick={(e) => { e.preventDefault(); handleNav("#services"); }}
                    className="flex items-center gap-2 text-white/50 hover:text-white text-sm transition-colors"
                  >
                    <span>{c.flag}</span>
                    <span>{c.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col gap-3">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/30 text-xs">
              © {currentYear} United Dream Mongolia. Бүх эрх хуулиар хамгаалагдсан.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-white/30 hover:text-white/60 text-xs transition-colors">
                Нууцлалын бодлого
              </a>
              <a href="#" className="text-white/30 hover:text-white/60 text-xs transition-colors">
                Үйлчилгээний нөхцөл
              </a>
            </div>
          </div>
          <p className="text-white/20 text-[10px] text-center leading-relaxed max-w-3xl mx-auto">
            Визийг зөвхөн холбогдох улсын элчин сайдын яам шийдвэрлэнэ. Виз гарах баталгааг бид өгөхгүй. Байгууллагын эрх хамгаалагдсан. Сайтанд байрласан зарим мэдээлэл зөрүүтэй байж болно. Визний магадлалыг зөвхөн бид өөрсдийн туршлага болон AI үндэслэж гарч байгаа тул бодит байдлаас зөрүүтэй байж болно.
          </p>
        </div>
      </div>
    </footer>
  );
}
